const quote = [
  "M14 1.6h-2.4a2 2 0 0 0-2 2V6a2 2 0 0 0 2 2H14c.14 0 .27-.01.4-.04V9.6a3.2 3.2 0 0 1-3.2 3.2h-.8a.8.8 0 1 0 0 1.6h.8A4.8 4.8 0 0 0 16 9.6v-6a2 2 0 0 0-2-2zM4.4 1.6H2a2 2 0 0 0-2 2V6a2 2 0 0 0 2 2h2.4c.14 0 .27-.01.4-.04V9.6a3.2 3.2 0 0 1-3.2 3.2H.8a.8.8 0 1 0 0 1.6h.8a4.8 4.8 0 0 0 4.8-4.8v-6a2 2 0 0 0-2-2z"
];
export {
  quote
};
//# sourceMappingURL=quote.js.map
